import {
  AutoComplete,
  Button,
  Drawer,
  Input,
  List,
  Popconfirm,
  Select,
  Space,
  Spin,
  Tag,
  message,
} from "antd";
import {
  CheckCircleOutlined,
  ArrowRightOutlined,
  CaretRightOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
import React from "react";
import { apiCallPost, apiCallPostCancellable, niceDateTime } from "../fns/util";
import _ from "lodash";
import PaperSubmissionForm from "../submissions/Paper";
import PosterSubmissionForm from "../submissions/Poster";
import VideoSubmissionForm from "../submissions/Video";
import ICSubmissionForm from "../submissions/InstructionCourse";

class SessionDetails extends React.Component {
  state = {
    isChanged: false,
    events: [],
    selectedRecord: null,
    showDrawer: false,
    searchResultsOSWB: [],
    people: [],
    isSearchingOSWB: false,
    isBusy: false,
  };
  componentDidMount() {
    this.getEventsBySession();
    this.setState({
      ...this.props.session,
    });
  }
  getEventsBySession = async () => {
    // if (!this.props.isAdmin) {
    //   return null;
    // }
    // let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023/getEventsBySession";

    try {
      this.setState({
        isBusy: true,
      });
      let res = await apiCallPost("token", apiUrl, {
        sessionId: this.props.session._id,
      });
      this.setState({
        events: res.events,
        isBusy: false,
      });
    } catch (err) {
      this.setState({
        isBusy: false,
      });
      message.error("Error fetching events in session");
      console.log(err);
    }
  };
  removeEventFromSession = async (eventId) => {
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023admin/removeEventFromSession";
    this.setState({
      isBusy: true,
    });
    try {
      message.loading("Removing event from session");
      await apiCallPost(token, apiUrl, {
        eventId,
      });
      let events = this.state.events.filter((each) => each._id !== eventId);
      this.setState({
        events: events,
        isBusy: false,
      });
      message.success("Event removed from session");
    } catch (err) {
      this.setState({
        isBusy: false,
      });
      message.error("Error removing event from session");
      console.log(err);
    }
  };
  handleSearch = async (searchText) => {
    if (!searchText || (searchText && searchText.length <= 2)) {
      return;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023/searchForParticipants";

    let stateKey = "isSearchingOSWB";

    try {
      this.setState({ [stateKey]: true });
      let res = await apiCallPostCancellable(token, apiUrl, {
        prefix: searchText,
        showOnlyRegistered: true,
      });
      if (res) {
        this.setState({
          searchResultsOSWB: res,
          [stateKey]: false,
        });
      }
    } catch (err) {
      console.log(err);
      this.setState({ [stateKey]: false });
    }
  };
  inviteDelegate = async (delegate) => {
    try {
      let token = await this.props.context.provideToken();
      this.setState({ isBusy: true });
      message.loading("Adding delegate to conference...");
      await apiCallPost(token, "/conference2023/inviteDelegate", {
        name: delegate.full_name,
        email: delegate.email,
        mobile: delegate.mobile_number ? "+91" + delegate.mobile_number : null,
      });
      message.success("Delegate invited successfully.");
      this.setState({ searchResultsOSWB: [] });
    } catch (err) {
      this.setState({ isBusy: false });
      console.log(err);
      message.error("Error inviting delegate.");
    }
  };
  handleAddFromSearch = (delegate) => {
    let person = delegate;
    let payload = {
      delegateId: person._id,
      name: person.full_name,
      email: person.email,
      mobile: person.mobile_number,
      role: "",
      sponsoredBy: "",
    };
    let people = this.state.people;
    // check if person already exists
    let existingPerson = people.find(
      (each) => each.delegateId === payload.delegateId
    );
    if (existingPerson) {
      message.error("This person is already added to the session.");
      return;
    }
    people.push(payload);
    this.setState({
      people: people,
      isChanged: true,
    });
  };
  saveSession = () => {
    this.props.saveSession({
      ...this.state,
    });
  };
  renderTitle = () => {
    if (this.props.isAdmin && this.props.mode === "EDIT") {
      return (
        <div>
          <Input
            disabled={this.props.isBusy}
            addonBefore="Session Title"
            style={{
              width: "100%",
            }}
            value={this.state.title}
            onChange={(e) => {
              this.setState({
                title: e.target.value,
                isChanged: true,
              });
            }}
          />
        </div>
      );
    }
    return <h3>{this.state.title}</h3>;
  };
  renderControlBar = () => {
    if (!this.props.isAdmin) {
      return null;
    }
    return (
      <div className="flex__push__apart" style={{ width: "100%" }}>
        <Space.Compact>
          {this.state.isChanged ? (
            <Space>
              <Tag color="volcano">Unsaved changes</Tag>
              <Button
                loading={this.props.isBusy}
                icon={<CheckCircleOutlined />}
                onClick={() => {
                  this.saveSession();
                }}
                type="primary"
              >
                Click to Save Changes
              </Button>
            </Space>
          ) : (
            <Tag>Last updated: {niceDateTime(this.state.updatedAt)}</Tag>
          )}
        </Space.Compact>
        {this.renderDeleteButton()}
      </div>
    );
  };
  renderDuration = () => {
    return (
      <Space direction="vertical">
        <Space.Compact>
          <Tag>{this.state.resourceId}</Tag>
          <CaretRightOutlined />{" "}
          <Tag>{_.startCase(_.lowerCase(this.state.onDay))}</Tag>
          <CaretRightOutlined /> <Tag>
            {niceDateTime(this.state.start)}
          </Tag>{" "}
          <ArrowRightOutlined />
          <Tag>{niceDateTime(this.state.end)}</Tag>
        </Space.Compact>
      </Space>
    );
  };
  renderSessionType = () => {
    let { sessionTypes } = this.props;
    let sessionTypesList = _.keys(sessionTypes).map((key) => {
      return {
        label: _.startCase(_.lowerCase(key)),
        value: key,
      };
    });
    if (this.props.isAdmin && this.props.mode === "EDIT") {
      return (
        <div
          style={{
            width: "100%",
          }}
        >
          <Tag>Session Type</Tag>
          <Select
            style={{ width: "100%" }}
            value={this.state.sessionType || "Not Selected"}
            disabled={this.props.isBusy}
            options={sessionTypesList}
            onChange={(value) => {
              this.setState({
                sessionType: value,
                isChanged: true,
              });
            }}
          />
        </div>
      );
    }
    return <Tag>{_.startCase(_.lowerCase(this.state.sessionType))}</Tag>;
  };
  renderSessionDescription = () => {
    if (this.props.isAdmin && this.props.mode === "EDIT") {
      return (
        <div>
          <Tag>Session Description</Tag>
          <Input.TextArea
            disabled={this.props.isBusy}
            value={this.state.sessionDescription}
            onChange={(e) => {
              this.setState({
                sessionDescription: e.target.value,
                isChanged: true,
              });
            }}
          />
        </div>
      );
    }
    return <div>{this.state.sessionDescription}</div>;
  };
  renderSessionSponsor = () => {
    let { sponsors } = this.props;
    let sponsorsList = sponsors.map((each) => {
      return {
        label: each,
        value: each,
      };
    });
    if (this.props.isAdmin && this.props.mode === "EDIT") {
      return (
        <div
          style={{
            width: "100%",
          }}
        >
          <Tag>Session Sponsor</Tag>
          <Select
            allowClear={true}
            style={{ width: "100%" }}
            disabled={this.props.isBusy}
            options={sponsorsList}
            value={this.state.sponsoredBy || "Not Selected"}
            onChange={(value) => {
              this.setState({
                sponsoredBy: value,
                isChanged: true,
              });
            }}
          ></Select>
        </div>
      );
    }
    if (this.state.sponsoredBy) {
      return <div>Sponsored By: {this.state.sponsoredBy}</div>;
    }
  };
  renderDeleteButton = () => {
    if (this.props.isAdmin && this.props.mode !== "EDIT") {
      return (
        <Button danger onClick={() => this.props.setMode("EDIT")}>
          Edit
        </Button>
      );
    }
    if (this.props.isAdmin && this.props.mode === "EDIT") {
      return (
        <div>
          {" "}
          <Button onClick={() => this.props.setMode("VIEW")}>
            {this.state.isChanged ? "Discard Changes" : "Done"}
          </Button>
          <Popconfirm
            title="Do you really want to delete this session? This cannot be undone."
            onConfirm={() => this.props.deleteSession(this.state._id)}
          >
            <Button danger>Delete</Button>
          </Popconfirm>
        </div>
      );
    }
    return null;
  };
  renderAddedEventsInSession = () => {
    if (!this.state.events || this.state.events.length === 0) {
      return null;
    }
    let data = this.state.events;
    return (
      <List
        size="small"
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item, index) => {
          let isAdmin = this.props.isAdmin;
          let actions = [
            <Button
              disabled={this.props.isBusy}
              onClick={() => {
                this.setState({
                  showDrawer: true,
                  selectedRecord: item,
                });
              }}
            >
              View Abstract
            </Button>,
          ];
          if (isAdmin && this.props.mode === "EDIT") {
            actions.push(
              <Popconfirm
                title="Remove this submission from the session?"
                onConfirm={() => {
                  this.removeEventFromSession(item._id);
                }}
              >
                <Button danger disabled={this.props.isBusy}>
                  Remove from session
                </Button>
              </Popconfirm>
            );
          }
          return (
            <List.Item key={index} actions={actions}>
              <List.Item.Meta
                title={item.title}
                description={
                  <div>
                    <Tag color="green">
                      {_.startCase(_.lowerCase(item.submissionType))}
                    </Tag>
                    {item.presentingAuthorName} | {item.awardTrack}
                  </div>
                }
              />
            </List.Item>
          );
        }}
      />
    );
  };
  renderDetailsDrawer = () => {
    if (!this.state.selectedRecord) {
      return null;
    }
    let type = this.state.selectedRecord.submissionType;
    let maps = {
      PAPER: (
        <PaperSubmissionForm
          preloadedData={this.state.selectedRecord}
          isAdmin={false}
          context={this.props.context}
        />
      ),
      POSTER: (
        <PosterSubmissionForm
          preloadedData={this.state.selectedRecord}
          isAdmin={false}
          context={this.props.context}
        />
      ),
      VIDEO: (
        <VideoSubmissionForm
          preloadedData={this.state.selectedRecord}
          isAdmin={false}
          context={this.props.context}
        />
      ),
      IC: (
        <ICSubmissionForm
          preloadedData={this.state.selectedRecord}
          isAdmin={false}
          context={this.props.context}
        />
      ),
    };
    return (
      <Drawer
        title={`Submission Details: ${this.state.selectedRecord.title}`}
        placement="right"
        closable={true}
        open={this.state.showDrawer}
        size="large"
        onClose={() => {
          this.setState({
            showDrawer: false,
            selectedRecord: null,
          });
        }}
      >
        {maps[type]}
      </Drawer>
    );
  };
  renderSearchPeopleBar = () => {
    if (!this.state.sessionType) {
      return null;
    }
    if (this.props.isAdmin && this.props.mode === "EDIT") {
      return (
        <Space direction="vertical">
          Add People To Session
          <>
            <AutoComplete
              popupMatchSelectWidth={true}
              style={{ width: 200 }}
              options={this.state.searchResultsOSWB.map((x) => ({
                label: (
                  <Space direction="vertical" size="small">
                    <Tag
                      color={
                        x.searchresultsrc === "SRC_OSWB" ? "magenta" : "blue"
                      }
                    >
                      {x.full_name}
                    </Tag>
                    {x.membership_id && <Tag>{x.membership_id}</Tag>}
                  </Space>
                ),
                value: `${x.full_name} ${x.email} ${
                  x.membership_id ? ` - ${x.membership_id}` : ""
                }`,
                delegate: x,
              }))}
              onSearch={(x) => this.handleSearch(x, false)}
              placeholder="Search Delegates"
              onSelect={(value, option) => {
                this.handleAddFromSearch(option.delegate);
              }}
            />
            {this.state.isSearchingOSWB && <Spin />}
          </>
        </Space>
      );
    } else {
      return null;
    }
  };
  renderPeopleList = () => {
    let data = this.state.people;
    if (!data || !data.length) {
      return null;
    }
    if (!this.state.sessionType) {
      return null;
    }

    if (this.props.isAdmin && this.props.mode === "EDIT") {
      return (
        <List
          bordered={true}
          size="small"
          dataSource={data}
          renderItem={(item) => {
            let sessionType = this.state.sessionType;

            let rolesInSession = this.props.sessionTypes[sessionType].map(
              (each) => {
                return {
                  label: each,
                  value: each,
                };
              }
            );
            let { sponsors } = this.props;
            let sponsorsList = sponsors.map((each) => {
              return {
                label: each,
                value: each,
              };
            });

            return (
              <List.Item key={item.delegateId}>
                <List.Item.Meta title={item.name} />
                Role:{"  "}
                <Select
                  options={rolesInSession}
                  value={item.role || "Not Selected"}
                  disabled={this.props.isBusy}
                  onChange={(value) => {
                    let people = this.state.people;
                    let person = people.find(
                      (each) => each.delegateId === item.delegateId
                    );
                    person.role = value;
                    this.setState({
                      people: people,
                      isChanged: true,
                    });
                  }}
                ></Select>
                <br />
                Sponsor:{"  "}
                <Select
                  allowClear={true}
                  disabled={this.props.isBusy}
                  options={sponsorsList}
                  value={item.sponsoredBy || "Not Selected"}
                  onChange={(value) => {
                    let people = this.state.people;
                    let person = people.find(
                      (each) => each.delegateId === item.delegateId
                    );
                    person.sponsoredBy = value;
                    this.setState({
                      people: people,
                      isChanged: true,
                    });
                  }}
                ></Select>
                <br />
                Description:{" "}
                <Input.TextArea
                  value={item.description}
                  onChange={(e) => {
                    let people = this.state.people;
                    let person = people.find(
                      (each) => each.delegateId === item.delegateId
                    );
                    person.description = e.target.value;
                    this.setState({
                      people: people,
                      isChanged: true,
                    });
                  }}
                ></Input.TextArea>
                <Popconfirm
                  title="Remove this person from session?"
                  onConfirm={() => {
                    let people = this.state.people.filter(
                      (each) => each.delegateId !== item.delegateId
                    );
                    this.setState({
                      people: people,
                      isChanged: true,
                    });
                  }}
                >
                  <Button danger icon={<UserDeleteOutlined />}>
                    Remove {item.name} from this session
                  </Button>
                </Popconfirm>
              </List.Item>
            );
          }}
        ></List>
      );
    }
    let sessionType = this.state.sessionType;
    let rolesInSession = this.props.sessionTypes[sessionType];
    /**
     * First, take all people and sort by role as in rolesInSession.
     */
    let people = this.state.people;
    let peopleByRole = {};
    rolesInSession.forEach((role) => {
      peopleByRole[role] = people.filter((each) => each.role === role);
    });
    /**
     * Now, render the list.
     */

    return rolesInSession.map((role) => {
      let peopleInRole = peopleByRole[role];
      if (!peopleInRole || !peopleInRole.length) {
        return null;
      }
      peopleInRole = _.sortBy(peopleInRole, ["name"]);
      return (
        <Space.Compact direction="vertical">
          <b>{role}</b>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {peopleInRole.map((each) => {
              return (
                <Space.Compact
                  direction="vertical"
                  style={{ marginTop: "10px" }}
                >
                  <Space>
                    <Tag color="green">{each.name}</Tag>
                  </Space>
                  {each.sponsoredBy && (
                    <Tag color="magenta">Sponsored By: {each.sponsoredBy}</Tag>
                  )}
                  {each.description && (
                    <Space>
                      <Tag color="blue">{each.description}</Tag>
                    </Space>
                  )}
                </Space.Compact>
              );
            })}
          </div>
        </Space.Compact>
      );
    });
  };
  render() {
    return (
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
      >
        {this.renderDetailsDrawer()}
        {this.renderControlBar()}
        {this.renderTitle()}
        {this.renderDuration()}
        {this.renderSessionType()}
        {this.renderSessionDescription()}
        {this.renderSessionSponsor()}
        {this.renderSearchPeopleBar()}
        {this.state.people.length > 0 && (
          <>
            <br />
            Delegates:
          </>
        )}
        {this.renderPeopleList()}
        {this.state.events.length > 0 && (
          <>
            <br />
            Submissions:
          </>
        )}
        {this.renderAddedEventsInSession()}
      </Space>
    );
  }
}

export default SessionDetails;
